import { useSyncExternalStore } from 'react'
import { audioLevel } from './audioLevel'

const GATE = 0.08 // 噪声门:低于此电平压平为静止,避免基准线被环境噪声搅得起伏

// 实时音浪:订阅 audioLevel(asr 每帧 push 的电平滚动缓冲),映射成各 bar 高度。
// 每根 bar 几何固定为满高、居中,只用 transform: scaleY 缩放(transform-origin 默认中心)——
// 中线被几何钉死、纯合成层变换不回流,所以基准线绝对不动,只有波形高低对称变化。bg-current 继承父级 text 色。
export function SoundWave({ heightClass = 'h-4' }: { heightClass?: string }) {
    const bars = useSyncExternalStore(audioLevel.subscribe, audioLevel.getBars, audioLevel.getBars)
    return (
        <span className={`inline-flex items-center gap-[3px] ${heightClass}`} aria-hidden>
            {bars.map((v, i) => {
                const g = v < GATE ? 0 : (v - GATE) / (1 - GATE)
                const s = 0.12 + g * 0.88 // 最小 0.12 留一条细中线
                return (
                    <span
                        key={i}
                        className="h-full w-[3px] rounded-full bg-current"
                        style={{ transform: `scaleY(${s})`, transition: 'transform 70ms linear' }}
                    />
                )
            })}
        </span>
    )
}
